import {Shimmer} from './Shimmer.js';
import {Shimmer2} from './Shimmer2.js';

class Basic {
	static init() {
		console.log(`Basic::init()`);
		Shimmer.init();
		Shimmer2.init();
	}	
}

document.addEventListener(`DOMContentLoaded`, Basic.init);